// extracted by mini-css-extract-plugin
export default {"hiddenInput":"uJXypX"};